module.exports = __webpack_public_path__ + "assets/img/lightSensorBlack.ce0bee70.png";